import React from 'react';
import { format, parseISO } from 'date-fns';
import { ClockIcon, MapPinIcon } from 'lucide-react';
import type { UpcomingClass } from '../../types/content';
import { BOOKING_URL, SITE } from '../../data/site';
import { getCourse } from '../../utils/courses';
import { ButtonLink } from '../ui/ButtonLink';
export function ClassCard({
  session
}: {
  session: UpcomingClass;
}) {
  const course = getCourse(session.courseSlug);
  if (!course) return null;
  const date = parseISO(session.date);
  const low = session.seatsLeft <= 3;
  return <article className="flex h-full overflow-hidden rounded-[4px] bg-white ring-1 ring-navy/10 shadow-[0_8px_24px_-14px_rgba(16,32,72,0.35)]" data-id="element-449" data-mp="3smlwr9jtd3e3">
      <div className="flex w-[4.75rem] shrink-0 flex-col items-center justify-center bg-accent text-white" data-id="element-450" data-mp="3ipze8reymof8">
        <span className="text-xs font-semibold uppercase tracking-[0.14em]" data-id="element-451" data-mp="3dr5xmq4dmhau">{format(date, 'MMM')}</span>
        <span className="font-display text-4xl font-bold leading-none" data-id="element-452" data-mp="39ost251d8pfn">{format(date, 'd')}</span>
        <span className="mt-1 text-xs uppercase tracking-wider text-white/85" data-id="element-453" data-mp="2nppogsqtbtet">{format(date, 'EEE')}</span>
      </div>
      <div className="flex flex-1 flex-col p-4" data-id="element-454" data-mp="2shr5st2u8abp">
        <div className="flex items-start justify-between gap-2" data-id="element-455" data-mp="2siiqh8uwcnn7">
          <span className="font-display text-xs font-semibold tracking-[0.12em] text-steel" data-id="element-456" data-mp="2dteazzfhkxis">{course.code}</span>
          <span className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${low ? 'bg-accent/10 text-accent' : 'bg-mist text-navy'}`} data-id="element-457" data-mp="2ir64gxvs4rp3">
            {low ? `Only ${session.seatsLeft} left` : `${session.seatsLeft} seats left`}
          </span>
        </div>
        <h3 className="mt-1 font-display text-lg font-semibold uppercase leading-tight text-navy" data-id="element-458" data-mp="2xfiwjjrqxqeb">{course.name}</h3>
        <ul className="mt-2 space-y-1 text-sm text-steel" data-id="element-459" data-mp="31j8nugzt2m31">
          <li className="flex items-center gap-1.5" data-id="element-460" data-mp="1lzuen6tcnhkd">
            <ClockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-461" data-mp="1q1z3ztcrls17" /> {session.time}
          </li>
          <li className="flex items-center gap-1.5" data-id="element-462" data-mp="3somhzscqz9mk">
            <MapPinIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-463" data-mp="3so4fidzhrz67" /> {SITE.location.shortName}
          </li>
        </ul>
        <div className="mt-auto pt-4" data-id="element-464" data-mp="3iz2zwowuzjsr">
          <ButtonLink href={BOOKING_URL} size="sm" className="w-full" ariaLabel={`Reserve a seat in ${course.name} on ${format(date, 'MMMM d')}`} data-id="element-465" data-mp="3iy1ebqi7vews">
            Reserve Seat
          </ButtonLink>
        </div>
      </div>
    </article>;
}